import { MemberType } from '../../types/Types';
import ActionTypes from '../Action.types';

type State = {
  members: MemberType[];
  isLoading: boolean;
};

type Action = {
  type: string;
  payload: any;
};

const MemberReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.start:
      return { ...state, isLoading: true };
    case ActionTypes.find:
      return { ...state, isLoading: false, members: action.payload };
    case ActionTypes.create:
      return {
        ...state,
        isLoading: false,
        members: [...state.members, action.payload],
      };
    case ActionTypes.update:
      return {
        ...state,
        isLoading: false,
        members: state.members.map((member) =>
          member._id === action.payload._id ? action.payload : member
        ),
      };
    case ActionTypes.delete:
      return {
        ...state,
        isLoading: false,
        members: state.members.filter(
          (member) => member._id !== action.payload
        ),
      };
    case ActionTypes.clear:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export default MemberReducer;
